import { EntityType, Rights } from '@frontend/common';
import { useModals } from '@frontend/modal';
import { NotificationTemplateClient } from '@frontend/notification/api';
import { NotificationTemplate } from '@frontend/notification/types';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppDispatch } from '../../../../redux/store';

export const useTemplateDetail = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { accountId, templateId } = useParams();
    const workingAccountId = accountId || currentAccount;
    const [template, setTemplate] = useState<NotificationTemplate | null>(null);
    const { openModal, closeModal } = useModals();
    const contentModalId = 'create-notification-content-modal';
    const templateModalId = 'update-notification-template-modal';

    useEffect(() => {
        if (!workingAccountId || !templateId) return;
        NotificationTemplateClient.fetchAccountNotificationTemplate(workingAccountId, templateId).then(setTemplate);
    }, [workingAccountId, templateId]);

    const notificationTemplatePermissions = (right: Rights) => [
        { item: EntityType.NOTIFICATION_TEMPLATE, source: EntityType.ACCOUNT, right, uid: workingAccountId },
        { item: EntityType.NOTIFICATION_TEMPLATE, source: EntityType.NOTIFICATION_TEMPLATE, right, uid: templateId ?? '?' }
    ];

    return {
        template,
        dispatch,
        navigate,
        openModal,
        closeModal,
        currentAccount: workingAccountId,
        contentModalId,
        templateModalId,
        createContentPermissions: notificationTemplatePermissions(Rights.CREATE),
        updateTemplatePermissions: notificationTemplatePermissions(Rights.UPDATE),
        deleteContentPermissions: notificationTemplatePermissions(Rights.DELETE),
        setTemplate
    };
};
